import { translate } from "app/filters/i18nFilter";

export const MARKET_SIZE_ENDPOINTS = {
    unique: "/widgetApi/IndustryAnalysisOverview/UniqueUsers/Graph",
    score: "/widgetApi/IndustryAnalysisOverview/UniqueUsers/Score",
};

interface IChangePeriod {
    quarterly: string;
    monthly: string;
    yearly: string;
}

interface IChangeText {
    label: IChangePeriod;
    tooltip: IChangePeriod;
}

interface IScoreText {
    label: string;
    tooltip: string;
}

export interface IMarketSizeText {
    title: string;
    uniqueVisitors: string;
    change: IChangeText;
    score: IScoreText;
}

export const getMarketPerformanceText = (): IMarketSizeText => ({
    title: translate("market.overview.marketsize.widget.title"),
    uniqueVisitors: translate("market.overview.marketsize.widget.unique.visitors"),
    change: {
        label: {
            quarterly: translate("market.overview.marketsize.widget.change.quaterly"),
            monthly: translate("market.overview.marketsize.widget.change.monthly"),
            yearly: translate("market.overview.marketsize.widget.change.yearly"),
        },
        tooltip: {
            quarterly: translate("industry.overview.marketsize.widget.change.quaterly.tooltip"),
            monthly: translate("industry.overview.marketsize.widget.change.monthly.tooltip"),
            yearly: translate("market.overview.marketsize.widget.change.yearly.tooltip"),
        },
    },
    score: {
        label: translate("industry.overview.marketsize.widget.score.title"),
        tooltip: translate("industry.overview.marketsize.widget.score.tooltip"),
    },
});
